import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: remCalc(8),
            alignSelf: 'stretch',
        },
        title: {
            textStyle: 'head-medium',
            color: 'text.default',
            fontWeight: 'medium',
        },
        description: {
            width: remCalc(330),
            textStyle: 'body-small',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        id: {
            width: remCalc(330),
            textStyle: 'body-xxsmall',
            color: 'text.secondary',
            fontWeight: 'normal',
        },
        favSvg: {
            boxSize: 'iconsSize.medium',
            color: 'background.dark',
            strokewidthnumber: remCalc(2),
            verticalAlign: 'unset',
            p: `${remCalc(1.2)} 0 ${remCalc(0.6)} 0`,
        },
        favSvgSolid: {
            boxSize: 'iconsSize.medium',
            color: 'background.alternative',
            strokewidthnumber: remCalc(2),
            verticalAlign: 'unset',
            p: `${remCalc(1.2)} 0 ${remCalc(0.6)} 0`,
        },
    },
}
